import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import {
  MENU_BUTTON_CODE,
  MENU_BUTTON_FORM,
  MobileView,
  TabNames,
  c1,
  c10,
  c2,
  c3,
  c4,
  c5,
  c6,
  c7,
  c8,
  c9,
  common_button_migration_map,
  common_components_map,
  common_tab_migration_map,
  errorMap,
  menu_button_map,
} from "./constants";
import { colorSchema, Menu, MenuButton, MenuRow, Message } from "./interface";
import { IndexDBService } from "./indexDB.service";
import { BuilderService } from "src/app/sharedservices/builder.service";
import { argbFromHex, CorePaletteColors, CorePalette, hexFromArgb, themeFromImage, Scheme } from "@material/material-color-utilities";

@Injectable({
  providedIn: "root",
})
export class MiddlwareService {
  constructor(
    public indexDBService: IndexDBService,
    public builderService: BuilderService
  ) {}
  id: any;
  email: any;
  token: any;
  order: any;
  chatID: any;
  user: any;
  date: any;
  chatList: any;
  selectedPlan: any;
  profile: any;
  tabList: any;
  returnUrl = "/";
  recharge_amount: any;
  showAdmin = false;
  menu_id: string;
  menu: any;
  balance: any;

  ////
  AppConfigVersion: number = 0;
  modes: any = [];
  atopBar: string =  "./assets/images/mobile/topbar.webp";

  anavBarL: string =  "./assets/images/mobile/navbarL.webp";      // for wider navBar
  anavBarS: string =  "./assets/images/mobile/navbarS.webp";

  afull: string = "./assets/images/mobile/emptyImageF.webp";
  aLong: string = "./assets/images/mobile/emptyImageL.webp";
  aShort: string = "./assets/images/mobile/emptyImageS.webp";
  aShortS: string = "./assets/images/mobile/emptyImageSS.webp";   // for wide nav bar

  ifull: string = "./assets/images/mobile/emptyImageF_ios.webp";    // to be replaced later on by iOS Hazem
  iLong: string = "./assets/images/mobile/emptyImageL_ios.webp";
  iShort: string =  "./assets/images/mobile/emptyImageS_ios.webp";
  iLongS: string = "./assets/images/mobile/emptyImageLS_ios.webp";        // for large font
  iShortS: string =  "./assets/images/mobile/emptyImageSS_ios.webp";      // for large font

  itopBar: string =  "./assets/images/mobile/topbar_ios.webp";
  itopbarTitle: string =  "./assets/images/mobile/topbar_title_ios.webp";      // for large font
  inavBar: string =  "./assets/images/mobile/navbar_ios.webp";


  view: string;


  async changeTab(data, mode, view?: boolean) {
    if (data && data.tab && data.tab.module) {
      switch (common_components_map[data.tab.module].type) {
        case TabNames.OPENCHAT:
        case TabNames.FEED:
        case TabNames.SEARCH:
        case TabNames.VIDEO:
        case TabNames.WEBVIEW:
        case TabNames.MENU:
        case TabNames.PAGE:
        case TabNames.QR:
        case TabNames.QR_PAGE:
        case TabNames.BOOKING:
        case TabNames.CALENDAR:
        case TabNames.CALL_LOG:
        case TabNames.CHANNELLIST:
        case TabNames.CHAT:
        case TabNames.CONTACT:
        case TabNames.MAP_SEARCH:
        case TabNames.GROUP:
        case TabNames.INVITATION:
        case TabNames.CHANNEL:
        case TabNames.OPENBOT:
        case TabNames.VIDEOAUDIO:
        case TabNames.ONLINEGROUP:
        case TabNames.ONLINECHANNEL:
        case TabNames.OPENGROUP:
        case TabNames.BOOKINGLIST:
        case TabNames.EMPTY:
        case TabNames.SPLASH:
        case TabNames.PALETTE:
          {
            if (
              data &&
              (common_components_map[data.tab.module].type === TabNames.MENU ||
                common_components_map[data.tab.module].type === TabNames.PAGE ||
                common_components_map[data.tab.module].type === TabNames.SPLASH)
            ) {
              await this.updateMenu(data);

              if (!data["menu"]) {
                data["menu"] = { ...this.menu };
              }
            }

            if (
              (data.tab.type != TabNames.EMPTY ||
                data.tab.module != TabNames.EMPTY) &&!view ) {
              // update the tab version
              data.tab.tab_version = this.makeRef(16);
              const response = this.indexDBService.updateItem("tab", data.tab);
              response.onsuccess = () => {
                let inputData = { ...data, mode: mode };
                this._updateBuilderComponentContainer.next(inputData);
              };
            } else {
              let inputData = { ...data, mode: mode };
              this._updateBuilderComponentContainer.next(inputData);
            }
          }
          break;
      }
    }
  }

  async updateMenu(inputData) {
    // input from subscription
    delete inputData["mode"];
    // if there in tab as input return menu

    if (inputData && inputData.tab.menu_id) {
      this.menu = await this.constructMenuSync(
        inputData.tab.menu_id
      );
    }

    // All menu , row and button are exist in the data.
    else if (
      inputData &&
      inputData["menu"] &&
      inputData["menu"].menu_id &&
      inputData["row"] &&
      inputData["row"].row_id &&
      inputData["button"] &&
      inputData["button"].button_id
    ) {
      if (inputData.menu["new"]) {
        delete inputData.menu["new"];
        inputData["menu"] = { ...inputData["menu"] };
      }
      if (inputData.button["new"]) {
        delete inputData.button["new"];
        inputData["button"] = {
          ...inputData["button"],
          ...menu_button_map[inputData["menu"].menu_id],
        };
      }

      // update the menu version
      inputData["menu"].menu_version = this.makeRef(16);
      const menu = this.indexDBService.updateItem("menu", inputData["menu"]);
      menu.onsuccess = async () => {
        inputData["row"].row_version = this.makeRef(16);

        const row = this.indexDBService.updateItem("row", inputData["row"]);
        row.onsuccess = async () => {
          inputData["button"].button_version = this.makeRef(16);

          const button = this.indexDBService.updateItem(
            "button",
            inputData["button"]
          );
          button.onsuccess = async () => {
            this.menu = await this.builderService.constructMenus(
              inputData.tab.menu_id
            );
          };
        };
      };
    }
    // only row and button are exist in the data.
    if (
      inputData &&
      !inputData["menu"] &&
      inputData["row"] &&
      inputData["row"].row_id &&
      inputData["button"] &&
      inputData["button"].button_id
    ) {
      if (inputData.button["new"]) {
        delete inputData.button["new"];
        inputData["button"] = {
          ...inputData["button"],
          ...menu_button_map[inputData["button"].button_code],
        };
      }

      inputData["row"].row_version = this.makeRef(16);
      const row = this.indexDBService.updateItem("row", inputData["row"]);
      row.onsuccess = async () => {
        inputData["button"].button_version = this.makeRef(16);
        const button = this.indexDBService.updateItem(
          "button",
          inputData["button"]
        );
        button.onsuccess = async () => {
          this.menu = await this.builderService.constructMenus(
            inputData.row.menu_id
          );
        };
      };
    }

    // only Menu is exist in the data.
    if (
      inputData &&
      inputData["menu"] &&
      inputData["menu"].menu_id &&
      !inputData["row"] &&
      !inputData["button"]
    ) {
      if (inputData.menu["new"]) {
        delete inputData.menu["new"];
        inputData["menu"] = { ...inputData["menu"] };
      }

      inputData["menu"].menu_version = this.makeRef(16);
      const menu = this.indexDBService.updateItem("menu", inputData["menu"]);
      menu.onsuccess = async () => {
        this.menu = await this.builderService.constructMenus(
          inputData.menu.menu_id
        );
      };
    }

    // only row is exist in the data.
    if (
      inputData &&
      !inputData["menu"] &&
      inputData["row"] &&
      inputData["row"].row_id &&
      !inputData["button"]
    ) {
      inputData["row"].row_version = this.makeRef(16);
      const row = this.indexDBService.updateItem("row", inputData["row"]);
      row.onsuccess = async () => {
        this.menu = await this.builderService.constructMenus(
          row.result.menu_id
        );
      };
    }

    // only button is exist in the data.
    if (
      inputData &&
      !inputData["menu"] &&
      !inputData["row"] &&
      inputData["button"] &&
      inputData["button"].button_id
    ) {
      if (inputData.button["new"]) {
        delete inputData.button["new"];
        inputData["button"] = {
          ...inputData["button"],
          ...menu_button_map[inputData["button"].button_code],
        };
      }

      inputData["button"].button_version = this.makeRef(16);
      const button = this.indexDBService.updateItem(
        "button",
        inputData["button"]
      );
      button.onsuccess = async () => {
        const row = this.indexDBService.getItem(
          "row",
          inputData["button"].row_id
        );
        row.onsuccess = async () => {
          this.menu = await this.builderService.constructMenus(
            row.result.menu_id
          );
        };
      };
    }
  }

  /// extract the dark color from original color.////////////////////
  ColorLuminance(hex, lum) {
    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, "");
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    let rgb = "#";
    let c;
    let i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      rgb += ("00" + c).substr(c.length);
    }

    return rgb;
  }

  public _editChat = new BehaviorSubject<any>(undefined);
  public editChat$ = this._editChat.asObservable();

  public _editUser = new BehaviorSubject<any>(undefined);
  public editUser$ = this._editUser.asObservable();

  public _scheduleMessageDate = new BehaviorSubject<any>(undefined);
  public scheduleMessageDate$ = this._scheduleMessageDate.asObservable();

  public _chatList = new BehaviorSubject<any>(undefined);
  public chatList$ = this._chatList.asObservable();

  public _selectedPlan = new BehaviorSubject<any>(undefined);
  public selectedPlan$ = this._selectedPlan.asObservable();

  public _editDomainContainer = new BehaviorSubject<any>(undefined);
  public editDomainContainer$ = this._editDomainContainer.asObservable();

  public _rechargeContainer = new BehaviorSubject<any>(undefined);
  public rechargeContainer$ = this._rechargeContainer.asObservable();

  public _idContainer = new BehaviorSubject<any>(undefined);
  public idContainer$ = this._idContainer.asObservable();

  public _emailContainer = new BehaviorSubject<any>(undefined);
  public emailContainer$ = this._emailContainer.asObservable();

  public _tokenContainer = new BehaviorSubject<any>(undefined);
  public tokenContainer$ = this._tokenContainer.asObservable();

  public _orderContainer = new BehaviorSubject<any>(undefined);
  public orderContainer$ = this._orderContainer.asObservable();

  public _profileContainer = new BehaviorSubject<any>(undefined);
  public profileContainer$ = this._profileContainer.asObservable();

  public _showAdminContainer = new BehaviorSubject<any>(undefined);
  public showAdminContainer$ = this._showAdminContainer.asObservable();
  public _showRootAdminContainer = new BehaviorSubject<any>(undefined);
  public showRootAdminContainer$ = this._showRootAdminContainer.asObservable();

  public _colorsComponentContainer = new BehaviorSubject<any>(undefined);
  public colorsComponentContainer$ =this._colorsComponentContainer.asObservable();


  public _updateBuilderComponentContainer = new BehaviorSubject<any>(undefined);
  public updateBuilderComponentContainer$ =this._updateBuilderComponentContainer.asObservable();

  public _updateButtonComponentContainer = new BehaviorSubject<MenuButton>(undefined);
  public updateButtonComponentContainer$ = this._updateButtonComponentContainer.asObservable();

  public _responseBuilderComponentContainer = new BehaviorSubject<any>(undefined);
  public responseBuilderComponentContainer$ =
    this._responseBuilderComponentContainer.asObservable();

  public _currentTabContainer = new BehaviorSubject<any>(undefined);
  public currentTabContainer$ = this._currentTabContainer.asObservable();

  public _currentMenuContainer = new BehaviorSubject<any>(undefined);
  public currentMenuContainer$ = this._currentMenuContainer.asObservable();

  public _offCanvasContainer = new BehaviorSubject<any>(undefined);
  public offCanvasContainer$ = this._offCanvasContainer.asObservable();

  public _offCanvasResponseContainer = new Subject<any>();
  public offCanvasResponseContainer$ = this._offCanvasResponseContainer.asObservable();

  public _selectedMessageRepliesContainer = new BehaviorSubject<Message>(null);
  public selectedMessageRepliesContainer$ = this._selectedMessageRepliesContainer.asObservable();

  public _userSavedNotifyContainer = new BehaviorSubject<any>(null);
  public userSavedNotifyContainer$ = this._userSavedNotifyContainer.asObservable();

  public _getAppConfigContainer = new Subject<any>();
  public getAppConfigContainer$ = this._getAppConfigContainer.asObservable();


  idSubscription = this.idContainer$.subscribe((received_id) => {
    this.id = received_id;
  });

  emailSubscription = this.emailContainer$.subscribe((received_email) => {
    this.email = received_email;
  });

  tokenSubscription = this.tokenContainer$.subscribe((received_token) => {
    this.token = received_token;
  });

  orderSubscription = this.orderContainer$.subscribe((received_order) => {
    this.order = received_order;
  });

  profileSubscription = this.profileContainer$.subscribe((received_profile) => {
    this.profile = received_profile;
  });

  rechargeSubscription = this.rechargeContainer$.subscribe(
    (received_amount) => {
      this.recharge_amount = received_amount;
    }
  );

  channelSubscription = this.editChat$.subscribe(
    (chatID) => (this.chatID = chatID)
  );

  userSubscription = this.editUser$.subscribe((user) => (this.user = user));
  dateSubscription = this.scheduleMessageDate$.subscribe((date) => (this.date = date));
  chatListSubscription = this.chatList$.subscribe(
    (chatList) => (this.chatList = chatList)
  );

  selectedPlanSubscription = this.selectedPlan$.subscribe(
    (plan) => (this.selectedPlan = plan)
  );

  getChatID() {
    return this.chatID;
  }
  getDate() {
    return this.date;
  }
  getUser() {
    return this.user;
  }

  getchatList() {
    return this.chatList;
  }

  getSelectedPlan() {
    return this.selectedPlan;
  }

  getID() {
    return this.id;
  }

  getEmail() {
    return this.email;
  }

  getToken() {
    return this.token;
  }

  getOrder() {
    return this.order;
  }

  getProfile() {
    return this.profile;
  }

  getRecharge() {
    return this.recharge_amount;
  }

  mapError(code: number) {
    return errorMap[code];
  }

  clear() {
    this.id = null;
    this.email = null;
    this.token = null;
    this.order = null;
    this.profile = null;
    this.returnUrl = "/";
  }

  makeRef(length: number) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  makRefNumber(length: number) {
    let result = "";
    const numbers = "0123456789";
    const numbersLength = numbers.length;
    let counter = 0;
    while (counter < length) {
      result += numbers.charAt(Math.floor(Math.random() * numbersLength));
      counter += 1;
    }
    return Number(result);
  }

  message(msg): Observable<void> {
    return msg;
  }

  localCommonComponentsMap(module) {
    return common_components_map[module];
  }

  isValidHexaCode(str) {
    // Regex to check valid
    // hexadecimalColor_code
    let regex = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);

    // if str
    // is empty return false
    if (str == null) {
      return "false";
    }

    // Return true if the str
    // matched the ReGex
    if (regex.test(str) == true) {
      return true;
    } else {
      return false;
    }
  }
  customColor (color){
    let schemes: { light:string, dark: string};
    schemes= {light:color, dark:color}
    return schemes
  }

  async saveBuilderDB(data) {
    if (data) {
      if (data.appConfig && data.appConfig.app && data.appConfig.app.version) {
        this.AppConfigVersion = data.appConfig.app.version.value ? data.appConfig.app.version.value : 0;
      } else {
        this.AppConfigVersion = 0;
      }
      let dBVersion: any = {}
      dBVersion = await this.indexDBService.getItemOnsucss("item", "version");
      if (!dBVersion || !dBVersion.value || dBVersion.value < this.AppConfigVersion) {
        if (data.appConfig){
          data.appConfig.app["version"] = { value: this.AppConfigVersion};
        }

        if (this.AppConfigVersion == 0 && data.onlineChannelConfigStaging) {
          console.log("staging");
          await this.saveOnlineChannelConfig(data.onlineChannelConfigStaging);
        } else {
          console.log("migratted");
          await this.saveOnlineChannelConfig(data.onlineChannelConfig);
        }

        await this.saveOnlineAppConfig(data.onlineAppConfig);
        await this.saveAppConfig(data.appConfig);
      }
      this._getAppConfigContainer.next(true);
    }
  }
  async saveOnlineChannelConfig(data) {
    let dbData: any = {};
    dbData = data;
    if (data && data.app) {
      dbData.app.menus =[];
      dbData.app.tabs.tabs = [];
      this.menusInsertion(data.app.menus)
      dbData = this.appStyle(data.app.tabs, dbData);
      this.tabsInsertion(data.app.tabs, "home")

      // add id
      if (!dbData.id) {
        dbData.id = "home";
      }
      // clean up
      if (dbData && dbData.app && dbData.app.side_menu) {
        delete dbData.app.side_menu;
      }
      await this.indexDBService.insertItem("app", dbData);
    } else {
      // no data
      let newData : any;
      newData = {id: "home", app: {menus:[], tabs:{tabs:[]}}}
      newData = this.appStyle(newData.app.tabs, newData);
      await this.indexDBService.insertItem("app", newData);
    }
  }
  menusInsertion (menus){
    if (menus) {
      let menuOrder = 0
      // menus insertions
      menus.forEach((menu) => {
        menu.cat = "menu";
       if (!menu.menu_version) {
          menu.menu_version = this.makeRef(16);
        }

        if (!menu.menu_order) {
          menu.menu_order = menuOrder;
        }
        menuOrder++;
        let rowOrder = 0;
        menu.rows.forEach((row) => {
          if (!row.menu_id) {
            row.menu_id = menu.menu_id;
          }
          if (!row.row_version) {
            row.row_version = this.makeRef(16);
          }
          if (!row.row_id) {
            row.row_id = menu.menu_id + rowOrder;
          }
          if (!row.row_order) {
            row.row_order = rowOrder++;
          }
                      let btnOrder = 0;
          row.buttons.forEach((btn) => {

            if (!btn.row_id) {
              btn.row_id = row.row_id;
            }
            if (!btn.button_order) {
              btn.button_order = btnOrder++;
            }
            if (!btn.button_verion) {
              btn.button_version = this.makeRef(16);
            }

            if (!btn.button_code && btn.button_form) {
              btn.button_code =
                common_button_migration_map[
                  btn.button_form
                ].button_code;
            }

            if (!btn.info && btn.button_code) {
              btn.info = menu_button_map[btn.button_code].info;
            }
            if (btn.button_code) {
              this.indexDBService.insertItem("button", btn);
            }
          });

          delete row.buttons;

          this.indexDBService.insertItem("row", row);
        });
        delete menu.rows;
        this.indexDBService.insertItem("menu", menu);
      });
    }
  }
  appStyle(tabs, dbData){
    if (tabs){
       if (!tabs.color_schema){
        dbData.app.tabs.color_schema = tabs.active_title_color? {source: tabs.active_title_color}: {source:'#386A1F'};
        let colors: any={}
        colors.primary =  dbData.app.tabs.color_schema.source
        dbData.app.tabs.color_schema = this.createColorsTheme('many', colors,null);
      }
      if (!tabs.color_schema_ios){
        dbData.app.tabs.color_schema_ios = {source:'#007aff'}
        let colors_ios: any={}
        colors_ios.primary =  '#007aff';
        colors_ios.secondary = '#767778';
        colors_ios.tertiary ='#bedbf8';
        dbData.app.tabs.color_schema_ios = this.createColorsTheme('many', colors_ios, null);

      }

      // tab style migration
      if (tabs.tab_style && !tabs.mode) {
          this.modes = [];
          switch (tabs.tab_style){
          case 0:
            // top wide
            this.modes =  [   {id:c4.ID,value:c4.TOP},  {id:c5.ID,value:c5.WIDE}, ];
          break;

          case 1:
            // bottom wide
            this.modes =  [   {id:c4.ID,value:c4.BOTTOM},  {id:c5.ID,value:c5.WIDE}, ];
          break;

          case 2:
            // Top Standard
            this.modes =  [   {id:c4.ID,value:c4.TOP},  {id:c5.ID,value:c5.STANDARD}, ];
            break;

          case 3:
            // bottom Standard
            this.modes =  [   {id:c4.ID,value:c4.BOTTOM},  {id:c5.ID,value:c5.STANDARD}, ];
          break;

        }
        this.changeMobileTheme(this.modes)
      }

      // tab style migration for IOS
      if (tabs.tab_style_ios) {
        this.modes = [];

        switch (tabs.tab_style_ios) {
          case 0:
            // Wide
            this.modes = [{ id: c10.ID, value: c10.WIDE },];
            break;

          case 1:
            // Standard
            this.modes = [{ id: c10.ID, value: c10.STANDARD },];
            break;
        }
        this.changeMobileTheme(this.modes)
      } else {

        console.log("log 3");
        this.modes = [{ id: c10.ID, value: c10.WIDE },];
        this.changeMobileTheme(this.modes)
      }

      // tab style migration for IOS
      if (tabs.tab_style_ios) {
        console.log("log 4");
        this.modes = [];
        switch (tabs.tab_style_ios) {
          case 0:
            // Wide
            this.modes = [{ id: c10.ID, value: c10.WIDE },];
            break;

          case 1:
            // Standard
            this.modes = [{ id: c10.ID, value: c10.STANDARD },];
            break;
        }
        this.changeMobileTheme(this.modes)
      } else {
        console.log("log 5");
        this.modes = [{ id: c10.ID, value: c10.WIDE },];
        this.changeMobileTheme(this.modes)
      }

      // Large and Small font for iOS
      if (tabs.large_tile) {
        console.log("log 6");
        this.modes = [];
        switch (tabs.large_title) {
          case 0:
            // Small Title
            this.modes = [{ id: c7.ID, value: c7.STANDARD },];
            break;

          case 1:
            // Standard
            this.modes = [{ id: c7.ID, value: c7.LARGE },];
            break;
        }
        this.changeMobileTheme(this.modes)
      }else {
        this.modes = [{ id: c7.ID, value: c7.STANDARD },];
        this.changeMobileTheme(this.modes)
      }
    }
    return dbData;
  }
  tabsInsertion(tabs, cat){
    if (tabs && tabs.tabs) {
      let tab_order: any = 0;
      tabs.tabs.forEach((tab) => {
        if (!tab.cat) {
          if (tab.layout && tab.layout === "button") {
            tab.cat = "next";
          } else {
            tab.cat = cat;
          }
        }
        if (!tab.tab_version) {
          tab.tab_version = this.makeRef(16);
        }
        if (!tab.tab_order) {
          tab.tab_order = tab_order;
        }
        tab_order++;
        if (this.AppConfigVersion == 0) {
          // migration  from version 0
          // setting the right icons
          tab.icon = common_tab_migration_map[tab.type].icon;
          tab.icon_ios =
            common_tab_migration_map[tab.type].icon_ios;
          if (
            tab.type == TabNames.FEED &&
            tab.footer &&
            tab.footer.action
          ) {
            for (let i = 0; i < tab.footer.action.length; i++) {
              switch (tab.footer.action[i].link) {
                case "like":
                  tab.footer.action[i].icon =
                    common_tab_migration_map[tab.type].like_icon;
                  break;
                case "reply":
                  tab.footer.action[i].icon =
                    common_tab_migration_map[
                      tab.type
                    ].reply_icon;
                  break;
                case "view":
                  tab.footer.action[i].icon =
                    common_tab_migration_map[tab.type].view_icon;
                  break;
                case "share":
                  tab.footer.action[i].icon =
                    common_tab_migration_map[
                      tab.type
                    ].share_icon;
                  break;
                case "like_highlight":
                  tab.footer.action[i].icon =
                    common_tab_migration_map[
                      tab.type
                    ].liked_icon;
                  break;
              }
            }
          }
          if (tab.sub_menus) {
            tab.sub_menus.forEach((menu_id) => {
              const response = this.indexDBService.getItem(
                "menu",
                menu_id
              );
              response.onsuccess = async () => {
                let menu = response.result;
                if (!menu.menu_group) {
                  menu.menu_group = tab.id;
                  this.indexDBService.updateItem("menu", menu);
                }
              };
            });
          }

          if (tab.menu_id) {
            const response = this.indexDBService.getItem(
              "menu",
              tab.menu_id
            );
            response.onsuccess = async () => {
              let menu = response.result;
              menu.menu_group = tab.id;
              this.indexDBService.updateItem("menu", menu);
            };
          }
        }
        if (!tab.module) {
          tab.module = tab.type; // temp solution to add module from type
        }
        this.indexDBService.insertItem("tab", tab);
      });
    }
  }
  createColorsTheme(type, baseColors, HTMLImageElement? ){
    if (type == 'image') {
      let colors: colorSchema = {
        schemes: { light: {}, dark: {} }, palettes: {
          primary: { keyColor: { id: null } },
          secondary: { keyColor: { id: null } }, tertiary: { keyColor: { id: null } }, error: { keyColor: { id: null } }, neutral: { keyColor: { id: null } }, neutralVariant: { keyColor: { id: null } }
        }
      }
      let theme: any = { schemes: { light: { props: {} } } }
      themeFromImage(HTMLImageElement).then(async (Theme) => {
        theme = Theme;
        Object.keys(theme.schemes.light.props).forEach(key => {
          colors.schemes.light[key] = hexFromArgb(theme.schemes.light.props[key]);
        })

        Object.keys(theme.schemes.dark.props).forEach(key => {
          colors.schemes.dark[key] = hexFromArgb(theme.schemes.dark.props[key]);
        })
        colors.source = hexFromArgb(theme.source);

        let palette: any;
        palette = theme.palettes;

        colors.palettes.primary.keyColor.id = hexFromArgb(palette.primary['keyColor']['argb']);
        colors.palettes.secondary.keyColor.id = hexFromArgb(palette.secondary['keyColor']['argb']);
        colors.palettes.tertiary.keyColor.id = hexFromArgb(palette.tertiary['keyColor']['argb']);
        colors.palettes.error.keyColor.id = hexFromArgb(palette.error['keyColor']['argb']);
        colors.palettes.neutral.keyColor.id = hexFromArgb(palette.neutral['keyColor']['argb']);
        colors.palettes.neutralVariant.keyColor.id = hexFromArgb(palette.neutralVariant['keyColor']['argb']);
        let updatedColros = this.additionalColors(palette, colors, 'image')

        // console.log("this.imageTheme", this.imageTheme);
        return  updatedColros
      })
    }

    if (baseColors && baseColors.primary){
      if (type == 'many') {
        let colors: colorSchema ={ schemes: { light: {}, dark: {} },  palettes:{ primary:{keyColor:{id:null}},
          secondary:{keyColor:{id:null} }, tertiary:{keyColor:{id:null} } , error:{keyColor:{id:null} }, neutral:{keyColor:{id:null} }, neutralVariant:{keyColor:{id:null} } }}

        let theme: any = {};
        let CorePaletteColors: CorePaletteColors = {
          primary: argbFromHex(baseColors.primary),
          secondary: baseColors.secondary? argbFromHex(baseColors.secondary): null,
          tertiary:  baseColors.tertiary? argbFromHex(baseColors.tertiary): null,
        }
        let palette: CorePalette;
        palette = CorePalette.contentFromColors(CorePaletteColors);
        theme.light = Scheme.lightFromCorePalette(palette);
        theme.dark = Scheme.darkFromCorePalette(palette);

        Object.keys(theme.light.props).forEach(key => {
          colors.schemes.light[key] = hexFromArgb(theme.light.props[key]);
        })

        Object.keys(theme.dark.props).forEach(key => {
          colors.schemes.dark[key] = hexFromArgb(theme.dark.props[key]);
        })

        colors.source = baseColors.primary

        colors.palettes.primary.keyColor.id = hexFromArgb(palette.a1['keyColor']['argb']);
        colors.palettes.secondary.keyColor.id  = hexFromArgb(palette.a2['keyColor']['argb']);
        colors.palettes.tertiary.keyColor.id  = hexFromArgb(palette.a3['keyColor']['argb']);
        colors.palettes.error.keyColor.id  = hexFromArgb(palette.error['keyColor']['argb']);
        colors.palettes.neutral.keyColor.id  = hexFromArgb(palette.n1['keyColor']['argb']);
        colors.palettes.neutralVariant.keyColor.id  = hexFromArgb(palette.n2['keyColor']['argb']);

        let updatedColros = this.additionalColors(palette, colors)

        console.log(" updated color ", updatedColros)
        return updatedColros
      }
    }
  }
  additionalColors(palette, colors, image?){
    let item = image? 'primary' : 'n1'
    // https://github.com/flutter/flutter/issues/137679

    colors.schemes.light.surfaceDim = hexFromArgb(palette[item].tone(87));
    colors.schemes.dark.surfaceDim = hexFromArgb(palette[item].tone(6));

    colors.schemes.light.surfaceBright = hexFromArgb(palette[item].tone(98));
    colors.schemes.dark.surfaceBright = hexFromArgb(palette[item].tone(24));

    colors.schemes.light.surfaceContainerLowest = hexFromArgb(palette[item].tone(100));
    colors.schemes.dark.surfaceContainerLowest = hexFromArgb(palette[item].tone(4));

    colors.schemes.light.surfaceContainerLow = hexFromArgb(palette[item].tone(96));
    colors.schemes.dark.surfaceContainerLow = hexFromArgb(palette[item].tone(10));

    colors.schemes.light.surfaceContainer = hexFromArgb(palette[item].tone(94));
    colors.schemes.dark.surfaceContainer = hexFromArgb(palette[item].tone(12));

    colors.schemes.light.surfaceContainerHigh = hexFromArgb(palette[item].tone(92));
    colors.schemes.dark.surfaceContainerHigh = hexFromArgb(palette[item].tone(17));

    colors.schemes.light.surfaceContainerHighest = hexFromArgb(palette[item].tone(90));
    colors.schemes.dark.surfaceContainerHighest = hexFromArgb(palette[item].tone(22));

    colors.schemes.light.surface = hexFromArgb(palette[item].tone(98));
    colors.schemes.dark.surface = hexFromArgb(palette[item].tone(6));

    //  delete colors.schemes.light.background   // use surface instead.
    //  delete colors.schemes.light.onBackground
    //  delete colors.schemes.light.surfaceVariant
    //  delete colors.schemes.dark.background   // use surface instead.
    //  delete colors.schemes.dark.onBackground
    //  delete colors.schemes.dark.surfaceVariant
    return colors
  }
  changeMobileTheme(modes, tab?) {
    // let modes =
    // [
    //   {id:c1.ID,value:c1.ANDRIOD},
    //   {id:c2.ID,value:c2.FULL},
    //   {id:c3.ID,value:c3.SINGLE},
    //   {id:c4.ID,value:c4.TOP},
    //   {id:c5.ID,value:c5.WIDE},

    //  {id:c6.ID,value:c6.BOTTOM},
    //  {id:c7.ID,value:c7.STANDARD},
    //  {id:c8.ID,value:c8.SIDE},
    // ]

    // this.mdw.changeMobileTheme(modes);

    let str = localStorage.getItem("mode");

    if (str && str.length != 10) {
      localStorage.setItem("mode", "ahmtwbsttw")
      str = "ahmtwbsttw"
    }

    // mode code as following xxxxxx
    // xxxxx as c1 c2 c3 c4 c5
    // c1: android and ios
    // c2: full, home, side, component
    // c3: single, notab, manytab
    // c4: android home- top, bottom
    // c5: android home- wide and narraw
    // c6: ios home - side menu top, bottom
    // c7: ios home - standard and large title
    // c8: android no side(false) and side (true)
    // c9: ios no side(false) and side (true)
    // c10: android home- wide and narraw(standard)


    let c1_value: string;
    let c2_value: string;
    let c3_value: string;
    let c4_value: string;
    let c5_value: string;
    let c6_value: string;
    let c7_value: string;
    let c8_value: string;
    let c9_value: string;
    let c10_value: string;


    var regc1 = /(?<=^.{0})./gi;
    var regc2 = /(?<=^.{1})./gi;
    var regc3 = /(?<=^.{2})./gi;
    var regc4 = /(?<=^.{3})./gi;
    var regc5 = /(?<=^.{4})./gi;
    var regc6 = /(?<=^.{5})./gi;
    var regc7 = /(?<=^.{6})./gi;
    var regc8 = /(?<=^.{7})./gi;
    var regc9 = /(?<=^.{8})./gi;
    var regc10 = /(?<=^.{9})./gi;

    modes.forEach(mode => {
      switch (mode.id) {
        case "c1":
          if (mode.value == c1.ANDRIOD) {
            c1_value = c1.ANDRIOD;
          } else {
            c1_value = c1.IOS;
          }
          str = str.replace(regc1, c1_value)
          break;
        case "c2":
          switch (mode.value) {
            case c2.FULL:
              c2_value = c2.FULL
              break;
            case c2.HOME:
              c2_value = c2.HOME;
              break;
            case c2.SIDE:
              c2_value = c2.SIDE
              break;
            case c2.COMPONENT:
              c2_value = c2.COMPONENT
              break;
          }
          str = str.replace(regc2, c2_value)
          break;

        case "c3":

          switch (mode.value) {
            case c3.SINGLE:
              c3_value = c3.SINGLE
              break;
            case c3.NOTAB:
              c3_value = c3.NOTAB
              break;
            case c3.MANYTAB:
              c3_value = c3.MANYTAB
              break;
          }
          str = str.replace(regc3, c3_value)
          break;

        case "c4":

          if (mode.value == c4.TOP) {
            c4_value = c4.TOP;
          } else {
            c4_value = c4.BOTTOM;
          }
          str = str.replace(regc4, c4_value)
          break;

        case "c5":

          if (mode.value == c5.WIDE) {
            c5_value = c5.WIDE
          } else {
            c5_value = c5.STANDARD
          }
          str = str.replace(regc5, c5_value)
          break;


        case "c6":

          if (mode.value == c6.TOP) {
            c6_value = c6.TOP
          } else {
            c6_value = c6.BOTTOM
          }
          str = str.replace(regc6, c6_value)
          break;

        case "c7":

          if (mode.value == c7.LARGE) {
            c7_value = c7.LARGE
          } else {
            c7_value = c7.STANDARD
          }
          str = str.replace(regc7, c7_value)
          break;

        case "c8":
          if (mode.value == c8.NOSIDE) {
            c8_value = c8.NOSIDE
          } else {
            c8_value = c8.SIDE
          }
          str = str.replace(regc8, c8_value)
          break;

        case "c9":
          if (mode.value == c9.NOSIDE) {
            c9_value = c9.NOSIDE
          } else {
            c9_value = c9.SIDE
          }
          str = str.replace(regc9, c9_value)
          break;

          case "c10":
            if (mode.value == c10.STANDARD) {
              c10_value = c10.STANDARD
            } else {
              c10_value = c10.WIDE
            }
            str = str.replace(regc10, c10_value)
            break;
      }

    });

    localStorage.setItem("mode", str);

    if (tab) {
      this.mobileTheme(tab);
      let data = { ...{ tab: tab } };
      this._updateBuilderComponentContainer.next(data);
    }
  }
  mobileTheme(tab?: any) {
    let mode = localStorage.getItem("mode");
    let data: any = {};

    if (mode && mode.length != 10) {
      localStorage.setItem("mode", "ahmtwbsttw")
      mode = "ahmtwbsttw"
    }

      switch (mode[0]) {
        case c1.ANDRIOD:
          {
            switch (mode[1]) {
              case c2.FULL: {
                //
                data["emptyImage"] = this.afull;
                data["view"] = MobileView.a_full;
                data["roundBottom"] = true;
                if (tab){
                  data["image"] = common_components_map[tab.module].android_url_f;
                }

              }
                break;
              case c2.HOME:
              case c2.SIDE:
                //
                {
                 if (mode[7] == c8.NOSIDE) {
                    data["hideside"] = true
                  } else {
                    data["hideside"] = false
                  }
                  data["sidemode"] = c2.SIDE ? true : false;

                  switch (mode[2]) {
                    case c3.SINGLE:
                      // single tab
                      {
                        data["emptyImage"] = this.aLong;
                        data["emptyImageTop"]= this.atopBar;
                        data["view"] = MobileView.a_main_tab
                        data["roundBottom"] = true;
                        if (tab){
                        data["image"] = common_components_map[tab.module].android_url_l;
                        }
                      }
                      break;

                    case c3.NOTAB:
                      // no tab
                      {
                        data["emptyImage"] = this.aLong;
                        data["emptyImageTop"]= this.atopBar;
                        data["view"] = MobileView.a_main_notab
                        data["roundBottom"] = true;
                        if (tab){
                        data["image"] = common_components_map[tab.module].android_url_l;
                        }
                      }
                      break;

                    case c3.MANYTAB:
                      // many tabs
                      switch (mode[3]) {
                        case c4.TOP:
                          // Top wide
                          if (mode[4] == c5.WIDE) {
                            data["emptyImage"] = this.aShortS;
                            data["emptyImageTop"]= this.atopBar;
                            data["emptyImageNavBar"]= this.anavBarL;
                            data["view"] = MobileView.a_main_many_top_wide;
                            data["roundBottom"] = false;
                            if (tab){
                            data["image"] = common_components_map[tab.module].android_url_s;
                            }
                          } else {
                            // Top Standard
                            data["emptyImage"] = this.aShort;
                            data["emptyImageTop"]= this.atopBar;
                            data["emptyImageNavBar"]= this.anavBarS;
                            data["view"] = MobileView.a_main_many_top_std;
                            data["roundBottom"] = true;
                            if (tab){
                            data["image"] = common_components_map[tab.module].android_url_s;
                            }
                          }

                          break;
                        case c4.BOTTOM:
                          // Bottom-wide
                          if (mode[4] == c5.WIDE) {
                            data["emptyImage"] = this.aShortS;
                            data["emptyImageTop"]= this.atopBar;
                            data["emptyImageNavBar"]= this.anavBarL;
                            data["view"] = MobileView.a_main_many_bottom_wide
                            data["roundBottom"] = false;
                            if (tab){
                            data["image"] = common_components_map[tab.module].android_url_s;
                            }
                          } else {
                            //Bottom Standard
                            data["emptyImage"] = this.aShort;
                            data["emptyImageTop"]= this.atopBar;
                            data["emptyImageNavBar"]= this.anavBarS;
                            data["view"] = MobileView.a_main_many_bottom_std
                            data["roundBottom"] = false;
                            if (tab){
                            data["image"] = common_components_map[tab.module].android_url_s;
                            }

                          }
                          break;
                      }
                      break;
                  }
                }

                break;
              case c2.COMPONENT:
                // Component
                {
                  data["emptyImage"] = this.aLong;
                  data["emptyImageTop"]= this.atopBar;
                  data["view"] = MobileView.a_component;
                  data["backNavComponent"]="ture";
                  data["roundBottom"] = true;
                  if (tab){
                  data["image"] = common_components_map[tab.module].android_url_l;
                  }
                }
                break;
            }
          }
          break;
        case c1.IOS:
          {
            switch (mode[1]) {
              case c2.FULL:
                //
                data["emptyImage"] = this.ifull;
                data["view"] = MobileView.i_full;
                data["roundBottom"] = true;
                if (tab){
                data["image"] = common_components_map[tab.module].ios_url_f;
                }
                break;
              case c2.HOME:
              case c2.SIDE:
{}
                if (mode[7] == c9.NOSIDE) {
                  data["hideside"] = true
                } else {
                  data["hideside"] = false
                }

                data["sidemode"] = c2.SIDE ? true : false;

                switch (mode[2]) {
                  case c3.SINGLE:
                    // single tab
                    {
                      if (mode[6] == c7.STANDARD) {
                      data["emptyImage"] = this.iLong;
                      data["emptyImageTop"]= this.itopBar;
                      data["emptyImageTitle"]= null;
                      data["emptyImageNavBar"]= null;
                      data["view"] = MobileView.i_main_tab
                      data["backNavComponent"]="ture";
                      data["roundBottom"] = true;
                      if (tab){
                      data["image"] = common_components_map[tab.module].ios_url_l;
                      }
                    } else {
                      data["emptyImage"] = this.iLongS;
                      data["emptyImageTop"]= this.itopBar;
                      data["emptyImageTitle"]= this.itopbarTitle;
                      data["emptyImageNavBar"]= null;
                      data["view"] = MobileView.i_main_tab
                      data["backNavComponent"]="ture";
                      data["roundBottom"] = true;
                      if (tab){
                      data["image"] = common_components_map[tab.module].ios_url_l;
                    }

                    }
                  }
                    break;

                  case c3.NOTAB:
                    // no tab
                    {
                      data["emptyImage"] = this.iLong;
                      data["emptyImageTop"]= this.itopBar;
                      data["emptyImageTitle"]= null;
                      data["view"] = MobileView.i_main_notab
                      data["backNavComponent"]="ture";
                      data["roundBottom"] = true;
                      if (tab){
                      data["image"] = common_components_map[tab.module].ios_url_l;
                      }
                    }
                    break;
                  case c3.MANYTAB:
                    // many tabs
                    switch (mode[5]) {
                      // c6: ios home side menu- top, bottom

                      case c6.BOTTOM:
                        if (mode[6] == c7.STANDARD) {
                          data["emptyImage"] = this.iShort;
                          data["emptyImageTop"]= this.itopBar;
                          data["emptyImageTitle"]= null;
                          data["emptyImageNavBar"]= this.inavBar;
                          data["view"] = MobileView.i_main_bottom_small;
                          data["roundBottom"] = false;
                          if (tab){
                          data["image"] = common_components_map[tab.module].ios_url_s;
                          }

                        } else {
                          data["emptyImage"] = this.iShortS;
                          data["emptyImageTop"]= this.itopBar;
                          data["emptyImageTitle"]= this.itopbarTitle;
                          data["emptyImageNavBar"]= this.inavBar;
                          data["view"] = MobileView.i_main_bottom_large;
                          data["roundBottom"] = false;
                          if (tab){
                          data["image"] = common_components_map[tab.module].ios_url_s;
                          }
                        }

                        break;

                      case c6.TOP:
                        if (mode[6] == c7.STANDARD) {
                          data["emptyImage"] = this.iShort;
                          data["emptyImageTop"]= this.itopBar;
                          data["emptyImageTitle"]= null;
                          data["emptyImageNavBar"]= this.inavBar;
                          data["view"] = MobileView.i_main_top_small;
                          data["backNavComponent"]="ture";
                          data["roundBottom"] = false;
                          if (tab){
                          data["image"] = common_components_map[tab.module].ios_url_s;
                          }

                        } else {
                          data["emptyImage"] = this.iShortS;
                          data["emptyImageTop"]= this.itopBar;
                          data["emptyImageTitle"]= this.itopbarTitle;
                          data["emptyImageNavBar"]= this.inavBar;
                          data["view"] = MobileView.i_main_top_large;
                          data["backNavComponent"]="ture";
                          data["roundBottom"] = false;
                          if (tab){
                          data["image"] = common_components_map[tab.module].ios_url_s;
                          }
                        }

                        break;
                    }
                    break;
                }

                break;

              case c2.COMPONENT:
                //
                {
                  data["emptyImage"] = this.iLong;
                  data["emptyImageTop"]= this.itopBar;
                  data["emptyImageTitle"]= null;
                  data["emptyImageNavBar"]= null;
                  data["view"] = MobileView.i_component;
                  data["backNavComponent"]="ture";
                  data["roundBottom"] = true;
                  if (tab){
                  data["image"] = common_components_map[tab.module].ios_url_l;
                  }
                }
                break;
            }
          }
          break;
      }
      return data;


  }
  async saveOnlineAppConfig(data) {
    let dbData: any = {};
    dbData = data;
    if (data && data.app) {
      if (data.app.tabs && data.app.tabs.tabs) {
         dbData.app.tabs.tabs = [];
         this.tabsInsertion( dbData.app.tabs, "side")
      }
      // add
      if (!dbData.id) {
        dbData.id = "side";
      }
      // clean up
      if (dbData && dbData.app && dbData.app.side_menu) {
        delete dbData.app.side_menu;
      }
      await this.indexDBService.insertItem("app", dbData);
    } else {
        // no data
        let newData : any;
        newData = {id: "home", app: {menus:[], tabs:{tabs:[]}}}
        await this.indexDBService.insertItem("app", newData);
    }
  }
  async saveAppConfig(data) {
    if (data && data.app) {
      await this.saveItem(data, "settings");
      await this.saveItem(data, "forms");
      await this.saveItem(data, "channel_default");
      await this.saveItem(data, "version");
      // save AppConfig.system item
      //await this.saveSystemItem(data, "color");
      await this.saveSystemAppInfoItem(data, "app_info");
      // save AppConfig.system.app_info item
      await this.saveAppInfoItem(data, "logo_color");
      await this.saveAppInfoItem(data, "logo_color_ios");
      await this.saveAppInfoItem(data, "logo_white");
      await this.saveItem(data, "splash");
    } else {
      let newData : any;
      newData = {app: {system: {app_info:{channel_name:"newApp"}}}, version: {value:0, id:"version"}}
      await this.saveItem(newData, "version");
      await this.saveSystemAppInfoItem(newData, "app_info");
    }

    if (data && data.app && data.app.splash && data.app.splash.id && data.app.splash.tab_id && this.AppConfigVersion > 0 ) {
      //new
      let screens = data.app.splash.screens;
      let tab: any = { param: { splash: {} } };
      tab["param"]["splash"] = data.app.splash;
      tab.id = data.app.splash.tab_id;
      tab.cat = "splash";
      tab.module = "splash"
      tab.type = "splash"
      tab.order = 0;
      tab.tab_version = data.app.splash.version;
      tab.menu_id = data.app.splash.menu_id;

      delete tab.version;
      delete tab.screens;
      await this.indexDBService.insertItem("tab", tab);
      ///////////  add the screens ///////////////////////
      screens.forEach((screen) => {
        if (screen) {
          let menu: any = { cat: "splash" };
          menu.cat = "splash";
          menu.menu_id = screen.menu_id;
          menu.menu_ref = screen.menu_id;
          menu.menu_version = screen.menu_id;
          menu.menu_group = tab.id;
          menu.menu_order = screen.order;


          let row: any = { row_id: "0" };
          row.row_id = menu.menu_id;
          row.menu_id = menu.menu_id;
          row.row_version = menu.menu_id;
          row.row_order = 0;
          let button: any ={button_id: "", 'info':{}, button_images:{  '01':{url: null, imageSet:[]}, 'default':{url:null, imageSet:[]} }};


        // button = structuredClone(menu_button_map[data.app.splash.style]);
          button.button_id = screen.id;
          button.button_callback = screen.id;
          button.button_version = screen.version;
          button.button_code = data.app.splash.style;
          button.button_form = "splash";
          button.button_type = "splash";
          button.button_style = data.app.splash.style;
          button.button_order = 0;
          button.button_label = screen.title;
          button.button_sublabel = screen.desc;
          button.button_img_url = screen.image;
          button.button_img_urlSet = screen.image_set;
          if (data.app.splash.style==='01'){
            button.button_images['01'].url = screen.image
            button.button_images['01'].imageSet = screen.image_set;
          }else {
            button.button_images['default'].url = screen.image
            button.button_images['default'].imageSet = screen.image_set;
          }
          button.button_bgimage = screen.bg_image;
          button.button_bgimageSet = screen.bg_image_set;
          button.button_bgstart = screen.start_color;
          button.button_bgend = screen.end_color;
          button.row_id = row.row_id;

          let button_code = 'splash_' + button.button_code ;
          button.info = menu_button_map[button_code].info;

          this.indexDBService.insertItem("menu", menu);
          this.indexDBService.insertItem("row", row);
          this.indexDBService.insertItem("button", button);
        }
      })

    } else {
      //old do nothing.
      this.createNewSplash();  //temp commeted out
    }
  }


  async saveItem(data, item) {
    let dbData: any = {};
    if (data.app[item]) {
      dbData = data.app[item];
      if (!dbData.id) {
        dbData.id = item;
      }
      await this.indexDBService.insertItem("item", dbData);
    }
  }

  async saveSystemItem(data, item) {
    let dbData: any = {};
    if (data.app.system && data.app.system[item]) {
      dbData = data.app.system[item];
      if (!dbData.id) {
        dbData.id = item;
      }
      await this.indexDBService.insertItem("item", dbData);
    }
  }

  async saveSystemAppInfoItem(data, item) {
    let dbData: any = {};
    if (data.app.system && data.app.system[item]) {
      dbData = data.app.system[item];
      if (!dbData.id) {
        dbData.id = item;
      }
      dbData.logo_color = {};
      dbData.logo_color_ios = {};
      dbData.logo_white = {};
      await this.indexDBService.insertItem("item", dbData);
    }
  }

  async saveAppInfoItem(data, item) {
    let dbData: any = {};
    if (
      data.app.system &&
      data.app.system.app_info &&
      data.app.system.app_info[item]
    ) {
      dbData = data.app.system.app_info[item];
      if (!dbData.id) {
        dbData.id = item;
      }
      await this.indexDBService.insertItem("item", dbData);
    }
  }

  createNewSplash(){
    console.log("I am here");
    /// create new tab
    // let id = this.mdw.makeRef(15);
    let id = 'splash'    // same id to prevent duplicate splash tab. Only one tab for splash should exist.
    let style = "01"
    let tabList = {};
    let current_tab: { cat: null , module: null};
    let sortedTabList = [];
    let menuList = {};
    let sortedMenuList = [];
    let menu: Menu;
    let row: MenuRow;
    let button: MenuButton;
    let max_buttons: number =6;

    let defaultRow: MenuRow = {
      row_id: "0",
      row_order: 0,
      menu_id: "0",
      buttons: [],
    };

    let defaultButton: MenuButton = {
      button_id: "0",
      row_id: "0",
      button_callback: "0",
      button_style: "0",
      button_style_ios: "0",
      button_form: "splash",
      button_code: "splash",
      button_order: 0,
      info: { min_grid: 60 },
    };


    tabList[id] = structuredClone(common_components_map["splash"]);
    tabList[id].id = id;
    // this.tabList[id].param.splash= structuredClone(splash_config_map[style].tab_part);
    tabList[id].param.splash.style= style;
    sortedTabList.push(tabList[id]);
    current_tab = tabList[id];

    /// create a new menu
    if (current_tab.cat == "splash") {
      let menu_id = "m_" + this.makeRef(15);

      tabList[id]["menu_id"] = menu_id;

      let newMenu: Menu = {
        menu_id: menu_id,
        menu_ref: menu_id,
        menu_version: menu_id,
        cat: "splash",
        menu_group: id,
        menu_order: 0,
      };

      menu = newMenu;

      /// create new row and button
      let row_id = "r_" + this.makeRef(15);
      let button_id = "b_" + this.makeRef(15);

      // add row
      let newRow = { ...structuredClone(defaultRow) };
      newRow.row_id = row_id;
      newRow.row_version = row_id;
      newRow.row_order = 0;
      newRow.menu_id = menu_id;
      newRow.row_lock = true;

      row = newRow;

      let button_style = "splash_"+ style
      // add button
      let newButton: any = {};
      newButton = structuredClone(menu_button_map[button_style]);

      // get it per template when switching //
      newButton.button_img_url = null;
      newButton.button_img_urlSet = null;
      newButton.button_images = { '01':{url:null},  'default':{url:null}    };
      newButton.button_bgimage=null;
      newButton.button_bgimageSet=null;
      newButton.button_bgstart=null;
      newButton.button_bgend =null;
      newButton.button_label = null;
      /////////////////////////////////////

      newButton.button_id = button_id;
      newButton.button_version = button_id;
      newButton.row_id = row_id;
      newButton.button_callback = button_id;
      newButton.button_order = 0;

      button = newButton;
      /// update tab
      let tabdata = {
        tab: current_tab,
        mode: localStorage.getItem('mode'),
      };
      this.changeTab(tabdata,  localStorage.getItem('mode'), false);

      let Menudata = {
        tab: {module:"splash"},
        menu: newMenu,
        row: newRow,
        button: newButton
      };

     this.changeTab(Menudata, localStorage.getItem('mode'), true);

      /////////////

      sortedMenuList.push(menu);
      menuList[menu.menu_id]=menu;

      let menuData: any ={rowList:{}, sortedRowList:[], buttonList:{}, sortedButtonList:[]};

      menuData["rowList"][row_id] =  {...newRow};
      menuData["sortedRowList"] =[...menuData["sortedRowList"],  menuData["rowList"][row_id]];
      menuData["buttonList"][button_id] ={...newButton};
      menuData["sortedButtonList"][row_id] = [];
      menuData["sortedButtonList"][row_id] =  [...menuData["sortedButtonList"][row_id], newButton];
      menuData["currentButton"]= {...newButton};


      menuData["tab"] = current_tab;
      menuData["defaultRow"] = defaultRow;
      menuData["defaultButton"] = defaultButton;
      menuData["max_buttons"] = max_buttons;
      menuData["menu"] = menu;
      menuData["module"] = current_tab.module;
      menuData["mode"] = localStorage.getItem('mode');

      menuData["menuList"] = menuList;
      menuData["sortedMenuList"] = sortedMenuList;

      this._currentMenuContainer.next(menuData); // to update menupages
    }
  }

  async constructMenuSync(menuId) {
    console.log("menuId", menuId);
    return await this.indexDBService
      .getItemOnsucss("menu", menuId)
      .then(async (menuResponse: any) => {
        let menu = menuResponse;
        if (menu) {
          menu.rows = await this.constructMenuRowsSync(menu.menu_id);
        }
        return await menu;
      });
  }

  async constructMenuRowsSync(menuId) {
    return await this.indexDBService
      .getItemListOnsucss("row", "menu", menuId)
      .then(async (rowResponse: any) => {
        let rows = await this.sortRows(rowResponse);
        let newRows = [];
        for (let i = 0; i < rows.length; i++) {
          rows[i].buttons = await this.constructMenuRowButtons(rows[i].row_id);
          newRows.push(rows[i]);
        }
        return newRows;
      });
  }

  async constructMenuRowButtons(rowId) {
    return await this.indexDBService
      .getItemListOnsucss("button", "row", rowId)
      .then(async (buttonResponse: any) => {
        let buttons = await this.sortButtons(buttonResponse);
        return buttons;
      });
  }

  sortRows(rows: any[]) {
    return rows.sort((a, b) => Number(a.row_order) - Number(b.row_order));
  }
  sortButtons(buttons: any[]) {
    return buttons.sort(
      (a, b) => Number(a.button_order) - Number(b.button_order)
    );
  }
}


